// @flow
import React from 'react';
import gql from 'graphql-tag';
import {graphql} from '@apollo/react-hoc';
import buildAnalyticsDataLayer from './buildAnalyticsDataLayer';

import {trigger as edapTrigger} from '../../utils/edapWrapper';

import type {SearchRequestQueryResults} from '../../queries/searchRequestQuery';

export const fragments = {
    SearchResult: gql`
        fragment ADLSearchResult on SearchResult {
            parsedParams {
                q
                coreFilters {
                    adults
                    children
                    pets
                    minBedrooms
                    maxBedrooms
                    minBathrooms
                    maxBathrooms
                    minNightlyPrice
                    maxNightlyPrice
                    minSleeps
                }
                dates {
                    arrivalDate
                    departureDate
                }
                sort
            }
            page
            pageSize
            pageCount
            resultCount
            fromRecord
            toRecord
            pinnedListing {
                listing {
                    listingId
                }
            }
            listings {
                listingId
            }
            filterGroups {
                filters {
                    checked
                    filter {
                        groupId
                        id
                    }
                }
            }
            geography {
                lbsId
                name
                description
                location {
                    latitude
                    longitude
                }
                primaryGeoType
                breadcrumbs {
                    name
                    countryCode
                    location {
                        latitude
                        longitude
                    }
                    primaryGeoType
                }
            }
        }
    `
};
export const requestmarkerQuery = gql`
    query requestmarkerQuery {
        requestmarker
    }
`;

type OwnProps = {
    requestmarker: string
};

export type Props = {
    results: ?SearchRequestQueryResults,
    data: OwnProps
};

export class AnalyticsDataLayer extends React.Component<Props> {
    componentDidMount() {
        this.updateADL({skipPageView: true});
    }

    componentDidUpdate({
        results: prevResults,
        data: {requestmarker: prevRequestmarker}
    }: Props) {
        // deep comparison with JSON.stringify shows better results especially for deep nested objects
        // https://www.measurethat.net/Benchmarks/Show/1854/0/lodash-isequal-test
        const prevResultsStr = JSON.stringify({
            ...prevResults,
            requestmarker: prevRequestmarker
        });
        const resultsStr = JSON.stringify({
            ...this.props.results,
            requestmarker: this.props.data.requestmarker
        });

        if (
            !!this.props.results &&
            !!this.props.data.requestmarker &&
            prevResultsStr !== resultsStr
        ) {
            this.updateADL({skipPageView: false});
        }
    }

    updateADL(options: {skipPageView: boolean}) {
        const {skipPageView} = options;

        if (this.props.results && this.props.data.requestmarker) {
            window.analyticsdatalayer = buildAnalyticsDataLayer(
                this.props.results,
                {
                    ...window.analyticsdatalayer,
                    requestmarker: this.props.data.requestmarker
                }
            );

            if (!skipPageView) {
                edapTrigger('edap.flush');
                edapTrigger('pageview');
            }
        }
    }

    render() {
        return null;
    }
}
export default graphql(requestmarkerQuery)(AnalyticsDataLayer);
